// Slovenščina - sl - 斯洛文尼亚语
const sl = {
  home: {
    home: 'Domov',
    solutions: 'Rešitve',
    support: 'Podpora',
    news: 'Novice',
    aboutUs: 'O nas',
    contactUs: 'Kontakt',
    cgm: 'CGM',
    download: 'Prenosi',
    helpCenter: 'Center za pomoč',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Vse pravice pridržane.',
    menu: 'Meni',
    quickLinks: 'Hitre povezave',
    contact: 'Kontakt',
    legal: 'Pravno',
    termsUse: 'Pogoji uporabe',
    privacyPolicy: 'Politika zasebnosti',
    portal: 'Uporabniški portal',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'E-pošta',
    subscribe: 'Naročite se',
    signUp: 'Prijavite se za prejemanje najnovejših novic',
    downloadApp: 'Prenesi aplikacijo',
    blogNews: 'Blog in novice',
    latestArticles: 'Najnovejši članki',
    viewAllArticles: 'Oglejte si vse članke',
    empower: 'Opolnomočite svojo zdravstveno pot z nami',
    empowerList1Content:
      'Hippo senzor je zelo olajšal obvladovanje sinove sladkorne bolezni. S HIPPOLINK lahko pregledno dostopamo do ravni njegove glukoze in z zaupanjem prilagodimo zdravljenje. To nas pomirja.',
    empowerList1Name:
      'Petra N., Češka (mati otroka s sladkorno boleznijo tipa 1)',
    empowerList2Content:
      'HIPPO senzor priporočamo pacientom zaradi stabilnega delovanja in daljšega časa uporabe. Povratne informacije uporabnikov so odlične, zlasti pri tistih, ki iščejo cenovno dostopnejšo rešitev.',
    empowerList2Name: 'Dr. Luca B., endokrinolog, Italija',
    empowerList3Content:
      'Pred kratkim sem začel uporabljati Hippo senzor — je udoben in natančen. Opozorila so mi pomagala preprečiti nizko glukozo ponoči. Z rezultati sem zelo zadovoljen.',
    empowerList3Name:
      'Fahad A., Savdska Arabija (bolnik s sladkorno boleznijo tipa 2)',
    reliable: 'Vaš zanesljiv partner pri obvladovanju sladkorne bolezni',
    hippoH1: 'HiPPO H1',
    challenges: 'Izzivi',
    constant: 'Neprekinjeno spremljanje krvnega sladkorja',
    traditional: 'Tradicionalno zbadanje prsta je lahko boleče in neprijetno',
    dataOverload: 'Preobremenitev s podatki',
    managing:
      'Upravljanje podatkov iz več virov je lahko zahtevno in težko razumljivo',
    treatment: 'Prilagoditve zdravljenja',
    accurately:
      'Določanje pravilnih ukrepov na podlagi vrednosti glukoze je lahko zapleteno',
    lifestyle: 'Vključitev v življenjski slog',
    balancing:
      'Usklajevanje prehrane, vadbe in zdravil z vsakodnevnimi dejavnostmi je lahko izziv',
    hippoCan: 'Hippo biosenzorji ponujajo',
    painless: 'Neboleče in diskretno spremljanje',
    ourCgm:
      'Naš senzor omogoča neprekinjeno merjenje glukoze brez zbadanja prsta',
    realTime: 'Podatki in vpogledi v realnem času',
    accessYour:
      'Do svojih podatkov lahko enostavno dostopate prek pametnega telefona in spremljate trende',
    personalized: 'Prilagojena podpora',
    ourCgmSys:
      'Opozorila in opomniki iz aplikacije Hippo BioSensors vam pomagajo ostati na pravi poti',
    improved: 'Boljše odločanje',
    gain: 'Boljše razumevanje odziva telesa vam omogoča učinkovitejše upravljanje nihanj glukoze',
    // about: 'O podjetju',
    companyProfile: 'Profil podjetja',
    banner1Title: 'Dobrodošli v Hippo Medical',
    banner1Content: 'V ospredju inovacij CGM',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Postavljamo nove standarde v tehnologiji CGM',
    banner3Content: '24-urna zaščita glukoze',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Vodilni na področju CGM tehnologije',
    // 错误提示
    subscribeSuccess: 'Naročnina uspešna', // ai翻译
    subscribeFailed: 'Naročnina ni uspela', // ai翻译
    invalidEmail: 'Neveljaven e-poštni naslov', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return sl.home.banner1Title;
    },
    get banner1Content() {
      return sl.home.banner4Content;
    },
    whyChoose: 'Zakaj izbrati HiPPO CGM',
    accurate: 'Natančnost, ki ji lahko zaupate',
    accurateText: 'Tretja generacija encimske tehnologije zagotavlja bolj',
    accurateText1: 'stabilno in natančno delovanje',
    easyUse: 'Enostavna uporaba',
    easyUseText: '14 dni neprekinjenega spremljanja',
    realTime: 'Spremljanje',
    realTimeText: 'Opozorila za hipo- in hiperglikemijo v realnem času',
    realTimeText1:
      'Deljenje podatkov v realnem času z družino in zdravstvenimi delavci',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Obveščeni kjerkoli in kadarkoli',
    withHippo: 'Z aplikacijami in portalom HiPPO',
    smallSensors: 'Majhni senzorji, udobno nošenje',
    agpReport:
      'Profesionalno AGP poročilo omogoča hitro pridobivanje ključnih informacij',
    unlimitedFollow:
      'Neomejeno spremljanje omogoča upravljanje več uporabnikov',
    iWatchApp: 'Na voljo aplikacija iWatch',
    certified: 'Certificirana uporaba za otroke',
    loremIp:
      'Sistem je klinično potrjen in uradno certificiran za uporabo pri otrocih, starejših od 3 let, kar zagotavlja varnost, natančnost in udobje za mlajše paciente. Z dokazano natančnostjo senzorja in nežnimi, koži prijaznimi materiali zagotavlja zanesljivo spremljanje glukoze pri otrocih in mladostnikih – kar podpira zdravstvene delavce pri zagotavljanju samozavestne in na podatkih temelječe oskrbe sladkornih bolnikov.',
  },
  news: {
    date: 'Datum',
    recommendedArticles: 'Priporočeni članki',
  },
  support: {
    download: 'Prenesi navodila',
    supportDown: 'Podpora/Prenosi',
  },
  about: {
    // welcome: 'Dobrodošli v Hippo Medical',
    // covered: 'Pokrite države',
    // patents: 'Patenti',
    // features: 'Funkcije3',
    // ring: 'Prstan',
    // apparently:
    //   'Pameten prstan, ki lahko spremlja parametre, kot so raven kisika v krvi, srčni utrip in spanec. Še pomembneje pa je, da ima algoritmično povezavo z našim CGM senzorjem. Lansiranje je predvideno leta 2026. Ostanite z nami!',
    // cgmSky:
    //   'Profesionalni CGM senzor, zasnovan tako za uporabo s strani pacientov kot za klinične potrebe zdravnikov. Ponuja visoko natančnost, uporabniku prijazno interakcijo s programsko opremo in ga poganjajo algoritmi Hippo Medical. Lansiran junija 2025!',
    // smartWatch: 'Pametna ura',
    // byTheSame:
    //   'Nosljiva naprava za dinamično merjenje krvnega tlaka, ki lahko neprekinjeno spremlja sistolični tlak, diastolični tlak, povprečni arterijski tlak in drugo, z algoritmom, ki ga je razvilo podjetje Hippo Medical. Lansiranje predvideno leta 2026. Ostanite z nami!',
    explore: 'Razišči',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPUR (409051)',
    zipCode: 'Poštna številka',
    emailCode: '409051',
    email: 'E-pošta',
    emailText: 'info@hippodiabetes.com',
    name: 'Ime*',
    company: 'Podjetje',
    message: 'Sporočilo',
    phone: 'Telefon',
    submit: 'Pošlji',
    // commingSoon: 'Kmalu na voljo',
    cpInfo1:
      'Hippo Medical je globalno medicinsko-tehnološko podjetje s sedežem v Singapurju, ki je predano revoluciji v obvladovanju kroničnih bolezni z nosljivimi biosenzorji medicinske kakovosti. Naša vizija je zagotavljati neprekinjeno spremljanje in napredno analizo podatkov.',
    cpInfo2:
      'Z razvojem biosenzorjev naslednje generacije in najsodobnejše platforme za podatkovno inteligenco si prizadevamo preoblikovati diagnostiko in utreti pot do bolj proaktivne in personalizirane prihodnosti.',
    submitFailed: 'Pošiljanje ni uspelo', // ai翻译
    get invalidEmail() {
      return sl.home.invalidEmail;
    },
    fillAllFields: 'Prosimo, izpolnite to polje', // ai翻译
  },
  download: {
    language: 'Jezik',
    product: 'Izdelek',
    unit: 'Enota',
    fetchFailed: 'Pridobivanje ni uspelo', // ai翻译
  },
  help: {
    search: 'Iskanje',
    support: 'Podpora/Center za pomoč/H1 CGM',
    source: 'Spletni viri HiPPO H1 CGM',
    viewAll: 'Prikaži vse',
    insert: 'Kako namestiti H1 CGM',
    setUp: 'Kako nastaviti aplikacijo H1',
    faq: 'Pogosta vprašanja HiPPO H1 CGM',
    freq: 'Pogosta vprašanja',
    noData: 'Vsebina ni bila najdena..',
    searchKeys: {
      warmUp: 'Napaka faze ogrevanja',
      waterLeakage: 'Puščanje vode',
      lowGlucose: 'Nizke vrednosti glukoze',
      cannotPair: 'Naprave ni mogoče povezati s pametnim telefonom',
    },
  },
  faq: {
    faq: 'FAQ',
    general: 'Splošna vprašanja',
    need: 'Potrebujete pomoč?',
    here: 'Tukaj so najpogostejša vprašanja',
    technical: 'Tehnična vprašanja',
  },
  lang: {
    chooseCountry: 'Izberite državo/regijo',
    northAmerica: 'Severna Amerika', // ai翻译
    southAmerica: 'Južna Amerika', // ai翻译
    europe: 'Evropa', // ai翻译
    africa: 'Afrika', // ai翻译
    asia: 'Azija', // ai翻译
    oceania: 'Oceanija', // ai翻译
    other: 'Drugo', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Suzhou, Kitajska',
      subName: 'Proizvodna lokacija',
      hovData:
        'Globalni sedež R&D/podatkovni center/prodajna pisarna za Azijo in Avstralijo',
    },
    dubai: {
      name: 'Dubaj',
      subName: 'Regionalna pisarna',
      hovData: 'Prodajna ekipa JV Azije',
    },
    singapore: {
      name: 'Singapur',
      subName: 'Sedež',
      hovData: 'Prodajna ekipa JV Azije',
    },
    sanFrancisco: {
      name: 'San Francisco, ZDA',
      subName: 'Regionalna pisarna',
      hovData: 'Prodajna ekipa Severne Amerike',
    },
    barcelona: {
      name: 'Barcelona',
      subName: 'Prodajna pisarna',
      hovData:
        'Globalni sedež R&D/podatkovni center/prodajna pisarna za Azijo in Avstralijo',
    },
  },
};
export default sl;
